import { getMatchOption } from './selectFn';

/**
 * 项目分类、业务线自动赋值
 */
const autoEvaluation = args => {
    const {
        type,                                   // 项目创建类型：CTA添加、JDE建号
        typeList,                               // 项目分类列表
        testeeTypeList,                         // 受试者类型列表
        businessList,                           // 业务线列表
        byStageList,                            // 项目分期列表
        disease,                                // 疾病
        jdeApplySceneId,                        // 场景ID
        jdeApplyIsInvestigationExists,          // 系统中是否有此项目
        isClinicalProject,                      // 是否是临床项目
        investigationMedicineType = [],              // 研究产品类型
        investigationByStageId,                 // 项目分期
        investigationAreaName,                  // 项目领域
        invAreaGroupType,                       // 领域为肿瘤分类invAreaGroupType=tumour_group
        testeeTypeId,                           // 受试者类型
        investigationCode,                      // 项目编号
        investigationName,                      // 项目名称
    } = args;

    // 不参与自动计算的情况
    if (
        (!jdeApplySceneId && jdeApplyIsInvestigationExists == 1) ||             // JDE建号：新建且有项目
        (jdeApplySceneId && jdeApplySceneId != 1 && jdeApplySceneId != 2)       // JDE建号：修改，且不是场景1或2
    ) {
        return {};
    }

    // 是临床项目
    const isClinicalPro = isClinicalProject == 1;
    // 将项目分类id数组 => name
    const names = (investigationByStageId || []).map(i => (byStageList.find(j => j.investigationByStageId == i) || {}).investigationByStageName).join(',');
    // 是否计算
    const shouldEvaluate = !!(
        investigationMedicineType[0] &&
        names &&
        Object.keys(disease).length &&
        investigationAreaName &&
        testeeTypeId
    );

    let investigationTypeName;
    let lineOfBusinessString;
    let secondLineNames;
    if (shouldEvaluate) {
        const { isCritical, lineOfBusinessName } = disease;
        if (isCritical == 1) {
            investigationTypeName = '危急症注册研究';
            lineOfBusinessString = '非肿瘤';
        } else {
            switch (investigationMedicineType[0]) {
            case 'Medical_instruments':
                investigationTypeName = '医疗器械研究';
                lineOfBusinessString = '综合';
                break;
            case 'Vaccines':
                investigationTypeName = '疫苗研究';
                lineOfBusinessString = '综合';
                break;
            case 'Diagnostic_reagent':
                investigationTypeName = '诊断试剂研究';
                lineOfBusinessString = '综合';
                break;
            case 'Others':
                investigationTypeName = 'NA';
                lineOfBusinessString = '综合';
                break;
            case 'Research_drugs':
            case 'Technology':
                switch (names) {
                case 'BE研究':
                    investigationTypeName = 'BE研究';
                    if (lineOfBusinessName == '肿瘤') {
                        lineOfBusinessString = '肿瘤';
                    } else if (lineOfBusinessName == '非肿瘤') {
                        lineOfBusinessString = '非肿瘤';
                    } else if (lineOfBusinessName == '综合') {
                        lineOfBusinessString = '综合';
                    }
                    break;
                case 'IV期':
                    investigationTypeName = '上市后IV期研究';
                    if (lineOfBusinessName == '肿瘤') {
                        lineOfBusinessString = '肿瘤';
                    } else if (lineOfBusinessName == '非肿瘤') {
                        lineOfBusinessString = '非肿瘤';
                    } else if (lineOfBusinessName == '综合') {
                        lineOfBusinessString = '综合';
                    }
                    break;
                case '研究者发起研究':
                    investigationTypeName = '研究者发起研究';
                    if (lineOfBusinessName == '肿瘤') {
                        lineOfBusinessString = '肿瘤';
                    } else if (lineOfBusinessName == '非肿瘤') {
                        lineOfBusinessString = '非肿瘤';
                    } else if (lineOfBusinessName == '综合') {
                        lineOfBusinessString = '综合';
                    }
                    break;
                case '观察性研究':
                case '真实性研究':
                case '流调':
                case '其他':
                    investigationTypeName = '观察性研究或真实性研究或回顾性或流行病学研究等';
                    if (lineOfBusinessName == '肿瘤') {
                        lineOfBusinessString = '肿瘤';
                    } else if (lineOfBusinessName == '非肿瘤') {
                        lineOfBusinessString = '非肿瘤';
                    } else if (lineOfBusinessName == '综合') {
                        lineOfBusinessString = '综合';
                    }
                    break;
                default:
                    const isFirstStage = names.indexOf('II') === -1;
                    const { typeValue } = getMatchOption(testeeTypeList, 'typeConfigureId', testeeTypeId);
                    if (isFirstStage && (typeValue === '健康人' || typeValue === '患者')) {
                        if (typeValue === '健康人') {
                            investigationTypeName = 'I期健康人研究';
                            lineOfBusinessString = '非肿瘤';
                        } else if (typeValue === '患者') {
                            investigationTypeName = 'I期患者研究';
                            lineOfBusinessString = lineOfBusinessName;
                        }
                    } else if (investigationAreaName === '肿瘤' || invAreaGroupType === 'tumour_group') {
                        investigationTypeName = '肿瘤注册研究';
                        lineOfBusinessString = '肿瘤';
                    } else {
                        investigationTypeName = '其他药物注册研究';
                        lineOfBusinessString = lineOfBusinessName;
                    }
                }
                break;
            }
        }
    }

    let containHeredity;
    // 是临床项目
    if (isClinicalPro) {
        // CTA添加
        if (type === 'CTA') {
            // 项目名称包含遗传办
            if (containHeredity = (investigationName || '').includes('遗传办')) {
                lineOfBusinessString = '综合';
            }
        // JDE建号
        } else if (type === 'JDE') {
            // 项目编号包含遗传办
            if (containHeredity = (investigationCode || '').includes('遗传办')) {
                lineOfBusinessString = '综合';
                secondLineNames = '遗传办';
            // 业务线赋值后
            } else if (shouldEvaluate && (investigationCode || '').includes('安全事务')) {
                secondLineNames = '安全事务';
            }
        }
    }

    const params = {};
    // 是临床，业务线才赋值
    if (isClinicalPro) {
        // 自动计算条件成立 或者 项目编号包含遗传办
        if (shouldEvaluate || containHeredity) {
            const { typeConfigureId, childList } = getMatchOption(businessList, 'typeValue', lineOfBusinessString);
            params.lineOfBusinessString = lineOfBusinessString;
            params.lineOfBusiness = typeConfigureId ? `${typeConfigureId}` : undefined;

            if (secondLineNames) {
                const { typeConfigureId } = getMatchOption(childList, 'typeValue', secondLineNames);
                params.secondLineNames = secondLineNames;
                params.secondLineIds = typeConfigureId ? `${typeConfigureId}` : undefined;
            }
        } else {
            params.lineOfBusinessString = undefined;
            params.lineOfBusiness = undefined;
        }
    }
    if (shouldEvaluate) {
        const { typeConfigureId } = getMatchOption(typeList, 'typeValue', investigationTypeName);
        params.investigationTypeName = investigationTypeName;
        params.typeId = typeConfigureId;
    } else {
        params.investigationTypeName = undefined;
        params.typeId = undefined;
    }

    return params;
};

export default autoEvaluation;



// WEBPACK FOOTER //
// ./src/components/shared/autoEvaluation.js